<template>
  <v-toolbar extended flat id="topBar" :height=60 :extension-height=40 app>
    <v-container fluid fill-height grid-list-md style="padding:5px;">
      <v-layout row>
        <img height="50" :src=logo alt="">
        <div style="color:white;margin:10px;padding:5px;font-size:36px;font-weight:bold;display:flex;justify-content:center;align-items:center;">WiDE Online</div>
        <v-spacer></v-spacer>
        <div v-show="userLogged" style="margin:0px 10px 0px 10px;">
          <div style="color:white;display:flex;justify-content:flex-end;align-items:center;height:50%;">{{ userName }}</div>
          <div style="color:rgb(218,218,218);display:flex;justify-content:flex-end;align-items:center;height:50%;">{{ companyName }}</div>
        </div>
        <v-avatar v-show="userLogged" v-on:click="goToSettings()">
          <img style="width:40px;height:40px;" :src="user" alt="">
        </v-avatar>
        <v-badge overlap color='rgb(205, 57, 64)' v-model="showAlert" ref="alertBadge" style="margin:10px;">
          <template v-slot:badge>
            <span>{{ alertCount }}</span>
          </template>
          <v-avatar tile="true" size="35" v-on:click="alertBadgeClick">
            <img style="width:20px;height:20px;" :src="notif" alt="">
          </v-avatar>
        </v-badge>
        <v-avatar tile="true" size="35" style="margin:10px;">
          <img style="width:20px;height:20px;" :src="ticket" alt="">
        </v-avatar>
        <v-menu v-model="alertMenu" :position-x="X" :position-y="Y" absolute offset-y :close-on-content-click="false">
          <AlertMenu :menu.sync="alertMenu"/>
        </v-menu>
        <v-menu bottom left offset-y>
          <template v-slot:activator="{ on }">
            <v-avatar tile="true" v-on="on">
              <img style="width:24px;height:24px;" :src="burger" alt="">
            </v-avatar>
          </template>
          <v-list>
            <v-list-tile v-for="item in items" :key="item" v-on:click="menuSelect(item)" :disabled="checkMenuItem(item)">
              <v-list-tile-title>{{ item }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-layout>
    </v-container>
    <v-dialog v-model="about" max-width="400px">
      <div style="background-color:white; justify-content:center; align-items:center; text-align:center; height:250px; max-height:250px; padding: 8px 0; color: rgb(51, 82, 128);">
        <div style="border-bottom: 1px solid rgb(51, 82, 128); margin: 0 5%; display: inline-grid; grid: 90% / auto auto auto; width: 90%; max-height: 4rem;">
          <div style="grid-column: 1;">
            <img height="50" :src=logo alt="">
          </div>
          <div style="grid-column: 2;">
            <h1>WiDE Online</h1>
          </div>
        </div>
        <!--<p style="margin: 16px 2.5% 0 2.5%; max-width: 95%; justify-content: stretch !important; text-align: justify; max-height: 4rem">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque eros erat, tempor quis dignissim vel, viverra non leo. Pellentesque interdum urna eget massa lobortis molestie.</p>-->
        <p style="margin: 16px 2.5% 0 2.5%; max-width: 95%; justify-content: stretch !important; text-align: justify; min-height: 4rem; max-height: 4rem"></p>
        <div style="width: 100%; height: 7.5rem; display: table;">
          <div style="display: table-cell; vertical-align: bottom;">
            <p style="line-height: 16px; padding: 0; margin: 8px;">Copyright (c) 2021 Winterthur Gas &amp; Diesel Ltd. (https://wingd.com). All rights reserved.</p>
            <p style="line-height: 16px; padding: 0; margin: 8px;">Version 1.1.8.4</p>
          </div>
        </div>
      </div>
    </v-dialog>
  </v-toolbar>
</template>

<script>

import AlertMenu from "./AlertMenu"
import {globalStore} from "../main.js"
import axios from 'axios';

export default {
  name: "Topbar",
  components: {
    AlertMenu
  },
  props: {
    userName: String,
    companyName: String
  },
  data: function () {
    return {
      logo: require('../assets/WiDE_Logo_Light.png'),
      burger: require('../assets/burger_active_dark.png'),
      notif: require('../assets/notifications.png'),
      ticket: require('../assets/ticket.png'),
      user: require('../assets/estLogo.png'),
      items: ['Report', 'Settings', 'About', 'Logout'],
      alertMenu: false,
      X: 0,
      Y: 0,
      about: false
    }
  },
  created() {
    if (typeof globalStore.userProfile.logo != 'undefined' && globalStore.userProfile.logo) {
      this.user = require('../assets/' + globalStore.userProfile.logo);
    }
  },
  methods: {
    checkMenuItem(menuItem) {
      if (menuItem == "Report") {
        if (globalStore.selectedIMO == '')
          return true;
        else {
          if (globalStore.twinEngine && globalStore.selectedEngine == '')
            return true;
          else
            return false;
        }
      } else
        return false;
    },
    async menuSelect(menuItem) {
      switch (menuItem) {
        case 'Settings':
          this.$router.push({path: '/user-settings'});
          break;
        case 'Report':
          this.$router.push({name: 'Report', params: this.$route.params});
          break;
        case 'About':
          this.about = true;
          break;
        case 'Logout':
          await axios.post(globalStore.config.api_location + '/logout', {'email': globalStore.userProfile.email}, {headers: {Authorization: globalStore.auth_token}});

          globalStore.userLogged = false;
          window.$cookies.remove('user');
          this.$router.push({path: '/login'});
          break;
        default:
          await axios.post(globalStore.config.api_location + '/logout', {'email': globalStore.userProfile.email}, {headers: {Authorization: globalStore.auth_token}});

          window.$cookies.set('login', 'An unexpected error occurred');
          globalStore.userLogged = false;
          window.$cookies.remove('user');
          this.$router.push({path: '/login'});
      }
    },
    alertBadgeClick() {
      this.alertMenu = false;
      this.X = this.$refs['alertBadge'].$el.offsetLeft + this.$refs['alertBadge'].$el.clientLeft;
      this.Y = this.$refs['alertBadge'].$el.offsetTop + this.$refs['alertBadge'].$el.clientTop + this.$refs['alertBadge'].$el.clientHeight;
      this.$nextTick(() => {
        this.alertMenu = true;
      });
    }
  },
  computed: {
    userLogged: function () {
      return globalStore.userLogged;
    },
    alertCount: function () {
      return globalStore.alerts.filter((alert) => {
        return alert.Fault || alert.action
      }).length;
    },
    showAlert: function () {
      return globalStore.alerts.length > 0;
    },
    alerts: function () {
      return globalStore.alerts;
    }
  },
  watch: {
    alertMenu() {
    }
  }
}
</script>

<style scoped>
#topBar {
  background-color: rgb(51, 82, 128);
  padding: 0px;
}
</style>
